module.exports = __webpack_public_path__ + "static/media/gh.5460b9ab.svg";